<template>
    <div>
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div class="section section-color center">
            <div class="w-container" style="padding:40px 0 0 0">
                <h1 class="key-number">{{$t('Contact_Us')}}</h1>
            </div>
        </div>

        <div class="page-content">
            <div class="address-container">
                <div class="address">
                    <div style="font-size: 24px;color:#0e0c1a;font-weight: bold">LocalScale</div>
                    <div style="font-size: 16px">201 West Main Street<br>Suite 300, PMB 302<br>Durham, NC 27701</div>
                </div>
            </div>

            <div style="margin-bottom: 50px">
                <div style="font-size: 20px;color:#0e0c1a;font-weight:bold;margin-bottom: 10px">Proudly made in Durham, NC</div>
                <a href="https://maps.app.goo.gl/J8GHBd9JSFXHbKEo8"><img src="images/durham.png" alt="Durham" width="600"></a>
            </div>

            <div class="form">
                <form id="contactUsForm" autocomplete="on" method="POST" action="https://ut9um6yb3j.execute-api.us-east-1.amazonaws.com/contact-us/localscale-contact-us-form-handler">
                    <input type="hidden" name="Page" value="Contact Us">

                    <b-field grouped>
                        <b-field :label="$t('first_name') + ' *'" style="margin-top: 0;margin-bottom: 0; width:48%">
                            <b-input type="text" name="First Name" required></b-input>
                        </b-field>

                        <b-field :label="$t('last_name') + ' *'" style="margin-top: 0;margin-bottom: 0;; width:49%">
                            <b-input type="text" name="Last Name" required></b-input>
                        </b-field>
                    </b-field>

                    <b-field :label="$t('email_address') + ' *'" style="margin-top: 0;margin-bottom: 0;">
                        <b-input type="email" name="Email Address" required></b-input>
                    </b-field>

                    <b-field :label="$t('company') + ' *'" style="margin-top: 0;margin-bottom: 0;">
                        <b-input type="text" name="Company" required></b-input>
                    </b-field>

                    <b-field :label="$t('subject') + ' *'" style="margin-top: 0;margin-bottom: 0;">
                        <b-input type="text" name="Subject" required></b-input>
                    </b-field>

                    <b-field :label="$t('message') + ' *'" style="margin-top: 0;margin-bottom: 0;">
                        <b-input type="textarea" name="Message" required></b-input>
                    </b-field>

                    <div align="left" style="padding-bottom: 30px">
                        <button class="ds-button button-small w-button" id="submit-button" type="submit">{{$t('submit')}}</button>
                    </div>
                </form>
            </div>
        </div>

        <Footer/>

    </div>
</template>

<script>
    import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
    import Footer from "../components/Footer";

    export default {
        components: {
            HeaderMenu, NetworkStatus, Footer
        }
    }
</script>

<style>
    .page-content {
        margin-left: auto;
        margin-right: auto;
        max-width: 800px;
        padding-bottom: 40px;
        padding-left: 1em;
        padding-right: 1em;
        text-align: center;
    }
    .header-text p {
        color: #636081;
    }
    .address-container {
        display: inline-grid;
        grid-template-columns: auto auto;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .address {
        padding: 20px 25px 25px 25px;
    }
    .label {
        color: #363636;
        background-color: #fff;
        text-align: left;
        margin-top: 0;
        margin-bottom: 0;
        padding: 0;
        display: block;
        font-size: 1rem;
        font-weight: 700;
    }
    .form {
        padding-left: 20px;
        padding-right: 20px;
        max-width: 550px;
        margin: auto;
    }
    .field, .control {
        text-align: left;
    }
    #submit-button {
        margin-top: 30px;
    }
</style>
